


export const SuperAdminPromoCode_START = 'SuperAdminPromoCode_START';
export const SuperAdminPromoCode_END = 'SuperAdminPromoCode_END';
export const SuperAdminPromoCode_ERROR = 'SuperAdminPromoCode_ERROR';
export const SuperAdminPromoCode_SUCCESS = 'SuperAdminPromoCode_SUCCESS';
export const SuperAdminPromoCode_FAIL = 'SuperAdminPromoCode_FAIL';
export const IsDataSubmitedSuccessfullySuperAdminPromoCode ='IsDataSubmitedSuccessfullySuperAdminPromoCode';